import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
import { extractCategoryHash } from '~/helpers/extract-helper';
export default {
  type: 'landing',
  aliases: ['landing'],
  slices: [{
    name: 'landing_header',
    path: 'Landing/LandingHeader.vue'
  }, {
    name: 'landing_header_with_image',
    path: 'Landing/LandingHeaderWithImage.vue'
  }, {
    name: 'collection_big_inspiration',
    path: 'Collection/CollectionBigInspiration.vue'
  }, {
    name: 'landing_image_text',
    path: 'Landing/LandingImageText.vue'
  }, {
    name: 'landing_video_text',
    path: 'Landing/LandingVideoText.vue'
  }, {
    name: 'offer_carousel',
    path: 'Global/GlobalCategoryProductsCarousel.vue',
    additional: {
      query: 'category',
      handler: function handler(arg) {
        return {
          filterBy: [],
          sortBy: 'POPULAR',
          orderBy: 'DEFAULT',
          hash: extractCategoryHash(arg.primary.button_url.url),
          offset: arg.primary.from,
          limit: arg.primary.size,
          enableRating: false
        };
      }
    }
  }, {
    name: 'offer_footer',
    path: 'Global/GlobalDispatchFooter.vue'
  }]
};